import { useTimeWorked } from "~components/TimeManagement/api/timeWorked";
import { useTranslation } from "~contexts/I18nContext/I18nContext";
import { SlideHeading } from "./SlideHeading";
import { TimeWorkedCards, TimeWorkedCardsSkeleton } from "./TimeWorkedCards";

export function TimeWorkedSlide({ showHeading }: { showHeading: boolean }) {
  const t = useTranslation();
  const { data: timeWorked, isLoading } = useTimeWorked({
    refetchInterval: 10_000,
  });

  return (
    <div>
      {showHeading && <SlideHeading>{t.timeWorkedHeading}</SlideHeading>}
      {isLoading || !timeWorked ? (
        <TimeWorkedCardsSkeleton />
      ) : (
        <TimeWorkedCards timeWorked={timeWorked} />
      )}
    </div>
  );
}
